export default (() => {

    function formatHours(hours) {

        return formatCpdTime(hours);
    }

    function formatMinutes(minutes) {

        return formatCpdTime(minutes);
    }

    function formatCpdTime(num) {

        num += '';

        while (num.length < 2) {

            num = '0' + num;
        }

        return num;
    }

    return {
        formatHours,
        formatMinutes
    };

})();


// WEBPACK FOOTER //
// ./services/cpdTimeFormatter.js